import { FormMeasuresResponseModel } from '@/domain/model/measures'

export const FAKE_MEASURES_DATA = (
  totalItems?: number
): FormMeasuresResponseModel => ({
  count: 1,
  next: null,
  previous: null,
  results: Array.from({ length: totalItems || 4 }).map((_, index) => ({
    downloadable: false,
    elation_pdf_report_type: null,
    auto_sign_off: false,
    enabled: true,
    has_office_use_questions: 0,
    id: `8f8003ed-22e2-4178-8e8f-b95b67e4b236${index}`,
    name: 'Measure Form',
    open_dental_pdf_report_type: null,
    packets: [],
    redirect_url: null,
    team: {
      address_city: '',
      address_state: '',
      address_street_1: 'hello',
      address_street_2: 'hello',
      address_zip: '',
      contact_email: '',
      contact_phone: '+16157990321',
      created_at: '2021-07-11T00:42:00.749016',
      integration: {
        integration_set: 'elation',
        auto_sign_off_enabled: true,
      },
      has_permission: true,
      id: 92,
      image:
        'https://api.dev.zentake.io/files/public/logos/eb55b38c-e772-42ea-8206-6124f002def4.jpg',
      is_subscribed: false,
      name: "Elation Sync's",
      stripe_integration: {
        id: 'b26de910-387a-4669-83c7-0fbc7dc8e27a',
        account_id: null,
        api_publishable_key:
          'pk_test_51QujzCIvTX1nhOt6xYAHHUwiYj54Sz6ZSRNcLYjPdCxFOYkwZZd5vetYJQ8V4bifg8UhSTcmTFc6k4yesSdFoxMl00yX1Fdorf',
        account_connection_status: 'CONNECTED',
      },
      config: {
        ask_dob: true,
        ask_email: false,
        client_label: null,
        initial_all: true,
      },
      uid: 'eb55b38c-e772-42ea-8206-6124f002def4',
      is_active: true,
      new_billing_flow: false,
      scheduled_forms: true,
      internal_forms: true,
      intake_ai: true,
      calculation_component: true,
      assigned_submission_owner: true,
      measures: false,
      require_2fa: false,
    },
    text: '',
    notification_users: [],
    is_internal_form: false,
    elation_pdf_non_fax: false,
    measure_enabled_at: '2025-03-14T03:16:31.527000',
  })),
})
